import { CheckBolderIcon, Flex, P } from '@equifinance/shared';
import styled from 'styled-components';
import { Status as ChecklistDecision } from '../../../contexts';
import ClockIcon from '../../Icons/ClockIcon';

const SubHeaderWrapper = styled(Flex)<{ status: ChecklistDecision, collapsed: boolean }>`
  ${({ theme, status, collapsed }) => {
    const getStatusBackgroundColor = (status: ChecklistDecision) => {
      switch (status) {
        case 'AWAITING DECISION':
          return theme.colours.neutral[10];
        case 'REJECTED':
          return theme.colours.danger[2];
        default:
          return theme.colours.success[2];
      }
    };

    return `
    min-height: ${theme.fontSize[10]};
    align-items: center;
    justify-content: flex-end;
    gap: ${theme.padding[3]};
    padding-inline: ${theme.padding[6]};
    border-radius: ${collapsed ? theme.borderRadius[2] : '0px'};
    border-bottom: ${collapsed || status !== 'AWAITING DECISION'
    ? '0px'
    : `${theme.borderWidth[1]} solid ${theme.colours.neutral[3]}`};
    background: ${getStatusBackgroundColor(status)};
    `;
  }
}`;

const Label = styled(P)`${({ theme }) => `
  color: ${theme.colours.neutral[2]};
`}`;

const Status = styled(P)`${({ theme }) => `
  margin-left: ${theme.padding[1]};
  font-family: 'Montserrat';
  color: ${theme.colours.neutral[2]};
  font-size: ${theme.fontSize[3]};
  letter-spacing: ${theme.letterSpacing[1]};
`}`;

const StatusWrapper = styled(Flex)`
  align-items: center;
`;

const StatusIconContainer = styled(Flex)<{ status: ChecklistDecision }>`
  ${({ theme, status }) => {
    const getStatusIconColor = (status: ChecklistDecision) => {
      if (status === 'REJECTED') {
        return theme.colours.danger[1];
      }

      return theme.colours.success[1];
    };

    return `
    align-items: center;
    justify-content: center;
    width: ${theme.fontSize[2]};
    height: ${theme.fontSize[2]};
    border-radius: ${theme.borderRadius[2]};
    background: ${getStatusIconColor(status)};
    `;
  }
}`;

const StatusIcon = styled.i`${({ theme }) => `
  color: ${theme.colours.neutral[10]};
  font-size: ${theme.padding[2]};
`}`;

function StatusMarker({ status }: { status: ChecklistDecision}) {
  return (
    <StatusIconContainer status={status}>
      {status === 'REJECTED' ? (
        <StatusIcon className="mi-close" />
      ) : (
        <CheckBolderIcon />
      )}
    </StatusIconContainer>
  );
}

type SubHeaderProps = {
  status: ChecklistDecision;
  collapsed: boolean;
};

export function SubHeader({ status, collapsed }: SubHeaderProps) {
  return (
    <SubHeaderWrapper status={status} collapsed={collapsed}>
      {!['AUTO-APPROVED', 'OVERRIDDEN'].includes(status) && (
        <Label>Underwriter’s decision:</Label>
      )}
      <StatusWrapper>
        {status === 'AWAITING DECISION'
          ? <ClockIcon />
          : <StatusMarker status={status} />}
        <Status>{status}</Status>
      </StatusWrapper>
    </SubHeaderWrapper>
  );
}
